import { m8API } from 'services/production/m8';
import { normalizeM8ProdStackDTO } from 'services/production/utils/normalizeM8ProdStackDTO';
import { GetProdStackInfoService } from 'types/services';

export const getProdStackInfo: GetProdStackInfoService = async () => {
  const m8TrialProdStack = await m8API.user.getProdStackInfo();

  if (m8TrialProdStack) {
    return normalizeM8ProdStackDTO(m8TrialProdStack).toProdStackInfo();
  }

  return null;
};
